import Navbar from "../../components/Navbar";
import "./css/accommodations.css"
import Footer from "../../components/Footer";

const Accommodations = () => {
    return (
        <main>
            <Navbar/>

            <div className="container accommodations__container">
                <hr/>
                <div className="accommodations__header">
                    <h1>HOMEWOOD SUITES BY HILTON PITTSBURGH DOWNTOWN</h1>
                    <h3>1410 SMALLMAN ST, </h3>
                    <h3>PITTSBURGH, PA, 15222</h3>
                    <h3>(412) 232-0200</h3>

                    <p>Check-In: Friday, June 19, 2026 | Check-Out: Sunday, June 21, 2026</p>
                    <p>Rate: $209+</p>

                    <p>Book your room <b><a className="text__black" rel="noreferrer" href="https://www.hilton.com/en/attend-my-event/pitdohw-trw-a223daef-d5bf-497d-85eb-4f181c06fdef/" target="_blank">here</a></b>.</p>
                    <p><b>Bookings must be made by May 10th, 2026 to receive room block rate</b></p>

                </div>

                <hr/>
                <div className="accommodations__header">
                    <h1>KIMPTON HOTEL MONACO PITTSBURGH</h1>
                    <h3>620 WILLIAM PENN PL,</h3>
                    <h3>PITTSBURGH, PA, 15219</h3>
                    <h3>(412) 471-1170</h3>

                    <p>Check-In: Friday, June 19, 2026 | Check-Out: Sunday, June 21, 2026</p>
                    <p>Rate: $289+</p>

                    <p>Book your room <u><b><a className="text__black" rel="noreferrer" href="https://book.passkey.com/e/51074253" target="_blank">here</a></b></u>.</p>
                    <p>To make a reservation by phone, call reservations at (833) 469-8452 and reference the: “Tomaswick - Reed Wedding Room Block” or block ID “Z3B”.</p>

                    <p><b>Bookings must be made by May 28th, 2026 to receive room block rate.</b></p>


                </div>
                <hr/>
            </div>
            <Footer/>
        </main>
    );
};

export default Accommodations;